// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Yerv","resendInfoText":"OnGoingPaymentBox_resendInfoText__2_o8S"};